import React, { Component } from 'react';
import LOOKUP from 'constants/lookup';
import DialogInput from 'screens/components/advanced/DialogInput';
import Button from 'screens/components/basic/Button';
import DialogHeaderWithClose from '../../../components/basic/DialogHeaderWithClose';

class ScheduleConfirmDelete extends Component {

    render(){
        const p = this.props;
        const actions = [
            <Button
                key="CancelButton"
                type="CancelButton"
                className="btn-space"
                label={LOOKUP.common.cancel.text}
                secondary={true}
                onTouchTap={this.props.close}
            />,
            <Button
                key="ConfirmButton"
                name="buttonJustThis"
                className="pull-right btn-space"
                label="Delete"
                primary={true}
                onTouchTap={this.props.deleteSchedule}
            />,
            // <Button
            //     key="SaveButton"
            //     name="buttonSave"
            //     className="pull-right mr-2"
            //     label="Cancel"
            //     onTouchTap={this.props.close}
            // />

        ];

        return(
            <div>
                <DialogInput
                    // title="Delete recursive schedule"
                    title={<DialogHeaderWithClose text="Delete recursive schedule" handleClose={() => this.props.close()} />}
                    modal={true}
                    actions = {actions}
                    className="schedule_dialog"
                    open={p.open}
                    autoScrollBodyContent={true}
                    >

                    <div className="row m-2">
                        Are you sure you want to delete this schedule?
                    </div>
                </DialogInput>
            </div>
        );
    }
}


export default ScheduleConfirmDelete;
